// extracted by mini-css-extract-plugin
module.exports = {"colors":"'styles/colors.module.css'","PRIMARY_DEFAULT":"#830051","linkRow":"styles_linkRow__h3LC7","link":"styles_link__NE1sU"};